// extracted by mini-css-extract-plugin
export default {"rating_scale":"Rate_rating_scale__t+5pY"};